import { FallbackLngObjList } from 'i18next';

export const CONFIG_UPDATE = 'CONFIG_UPDATE';
export const CONFIG_OAUTH_UPDATE = 'CONFIG_OAUTH_UPDATE';

export interface ConfigState {
  easterEggKeys?: any;
  langFallBack: FallbackLngObjList;
  langs?: string[];
  langWhiteList: string[];
  lslApi: string;
  lv?: string;
  limitedLangs?: {
    [lang: string]: string[];
  };
  printStateModel?: {
    default?: any;
  };
  regionalMap?: {
    [region: string]: { lslApi: string };
  };
  privacyPolicy?: {
    [language: string]: string;
  };
  termsOfUse?: {
    [language: string]: string;
  };
}

interface UpdateConfigAction {
  type: typeof CONFIG_UPDATE;
  config: ConfigState;
  country: string;
}

interface UpdateConfigOauthAction {
  type: typeof CONFIG_OAUTH_UPDATE;
  privacyPolicy: OauthConfigResponse['privacyPolicy'];
  termsOfUse: OauthConfigResponse['termsOfUse'];
}

export type ConfigActions = UpdateConfigAction | UpdateConfigOauthAction;
